import React, { useState, useEffect } from 'react';
import { User, Award, Clock, Activity, Settings, Shield, Bell, Zap } from 'lucide-react';

const Profile = () => {
  const [proMode, setProMode] = useState(localStorage.getItem('proMode') === 'true');
  const [saveToCloud, setSaveToCloud] = useState(true);
  
  useEffect(() => {
    localStorage.setItem('proMode', proMode);
  }, [proMode]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
      
      {/* Profile Header */}
      <div className="glass-panel" style={{ display: 'flex', gap: '24px', alignItems: 'center', flexWrap: 'wrap' }}>
        <div style={{ 
          width: '100px', height: '100px', borderRadius: '50%', 
          background: 'linear-gradient(135deg, var(--primary-color), var(--accent-color))',
          display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white'
        }}>
          <User size={48} />
        </div>
        <div>
          <h1 style={{ margin: '0 0 8px', color: 'var(--text-main)' }}>Interpreter Dashboard</h1>
          <p style={{ margin: 0, color: 'var(--text-muted)', display: 'flex', gap: '8px', alignItems: 'center' }}>
            <Shield size={16} color="var(--primary-color)" /> Verified SignAI User
          </p>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="dashboard-grid">
        <div className="glass-panel stat-card" style={{ background: 'rgba(101, 146, 135, 0.05)' }}>
          <div className="stat-icon"><Award /></div>
          <div className="stat-info">
            <h3>Total Signs Detected</h3>
            <p>12,482</p>
          </div>
        </div>
        <div className="glass-panel stat-card" style={{ background: 'rgba(136, 189, 164, 0.05)' }}>
          <div className="stat-icon" style={{ color: 'var(--accent-color)' }}><Activity /></div>
          <div className="stat-info">
            <h3>Avg Accuracy</h3>
            <p>94.2%</p>
          </div>
        </div>
        <div className="glass-panel stat-card" style={{ background: 'rgba(177, 211, 185, 0.05)' }}>
          <div className="stat-icon" style={{ color: 'var(--success)' }}><Clock /></div>
          <div className="stat-info">
            <h3>Active Hours</h3>
            <p>24.5h</p>
          </div>
        </div>
      </div>

      {/* Settings Section */}
      <div className="glass-panel">
        <h2 style={{ margin: '0 0 24px', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Settings size={24} color="var(--primary-color)" /> Preferences & Pro Features
        </h2>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px', paddingBottom: '20px', borderBottom: '1px solid var(--glass-border)' }}>
            <div>
              <h3 style={{ margin: '0 0 4px', color: 'var(--text-main)', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Zap size={18} color="#f59e0b" /> Pro Analytics HUD
              </h3>
              <p style={{ margin: 0, fontSize: '14px', color: 'var(--text-muted)' }}>Show real-time machine learning data, finger joint angles, and AI confidence streams on the Translate screen.</p>
            </div>
            <label style={{ position: 'relative', display: 'inline-block', width: '52px', height: '28px' }}>
              <input type="checkbox" checked={proMode} onChange={() => setProMode(!proMode)} style={{ opacity: 0, width: 0, height: 0 }} />
              <span style={{ 
                position: 'absolute', cursor: 'pointer', top: 0, left: 0, right: 0, bottom: 0, 
                backgroundColor: proMode ? 'var(--primary-color)' : 'rgba(0,0,0,0.2)', transition: '.4s', borderRadius: '34px' 
              }}>
                <span style={{ position: 'absolute', height: '20px', width: '20px', left: proMode ? '28px' : '4px', bottom: '4px', backgroundColor: 'white', transition: '.4s', borderRadius: '50%' }}></span>
              </span>
            </label>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px', paddingBottom: '20px', borderBottom: '1px solid var(--glass-border)' }}>
            <div>
              <h3 style={{ margin: '0 0 4px', color: 'var(--text-main)' }}>Auto-Save to Cloud</h3>
              <p style={{ margin: 0, fontSize: '14px', color: 'var(--text-muted)' }}>Automatically upload transcriptions to Firebase when clearing the board.</p>
            </div>
            <label style={{ position: 'relative', display: 'inline-block', width: '52px', height: '28px' }}>
              <input type="checkbox" checked={saveToCloud} onChange={() => setSaveToCloud(!saveToCloud)} style={{ opacity: 0, width: 0, height: 0 }} />
              <span style={{ 
                position: 'absolute', cursor: 'pointer', top: 0, left: 0, right: 0, bottom: 0, 
                backgroundColor: saveToCloud ? 'var(--primary-color)' : 'rgba(0,0,0,0.2)', transition: '.4s', borderRadius: '34px' 
              }}>
                <span style={{ position: 'absolute', height: '20px', width: '20px', left: saveToCloud ? '28px' : '4px', bottom: '4px', backgroundColor: 'white', transition: '.4s', borderRadius: '50%' }}></span>
              </span>
            </label>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
            <div>
              <h3 style={{ margin: '0 0 4px', color: 'var(--text-main)', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Bell size={18} color="var(--primary-color)" /> Push Notifications
              </h3>
              <p style={{ margin: 0, fontSize: '14px', color: 'var(--text-muted)' }}>Receive daily reminders to practice signing.</p>
            </div>
            <button className="btn" style={{ background: 'rgba(101,146,135,0.1)', color: 'var(--primary-color)' }}>Enable</button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Profile;
